import { css } from '@emotion/css';
import { Color } from 'src/styles';

export const mSwitch = css`
  &:hover:not(:focus) {
    background-color: ${Color.Brand5} !important;
  }
`;
